<template>
  <basic-container>

        <div
      class="path-container"
      style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px"
    >
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>家庭医生工作站</el-breadcrumb-item>
        <el-breadcrumb-item>会员管理</el-breadcrumb-item>
        <el-breadcrumb-item>亚健康标签</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <avue-crud
      :option="option"
      :data="data"
      ref="crud"
      v-model="form"
      :permission="permissionList"
      :page.sync="page"
      @on-load="onLoad"
    >
      <template slot="menuLeft"> </template>
      <template slot-scope="scope" slot="menu">
        <el-button type="text" size="small" @click="archiveType(scope.row)">
          档案信息
        </el-button>
        <!-- <el-button type="text" size="small" @click="datashow(scope.row)">
          动态数据展示
        </el-button> -->
        <el-button type="text" size="small" @click="datashow(scope.row)">
          动态数据达标
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { getSubHealth } from "@/api/health/manage";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        tip: false,
        border: true,
        // index: true,
        viewBtn: true,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        menu: false,
        // selection: true,
        column: [
          {
            label: "体质指数",
            prop: "bmi",
            // search: true
          },
          {
            label: "睡眠状况",
            prop: "sleep",
            // search: true
          },
          {
            label: "心理状态",
            prop: "psychology",
            // search: true
          },
          {
            label: "睡眠呼吸暂停",
            prop: "breath",
          },
          {
            label: "非酒精性脂肪肝",
            prop: "liver",
          },
          {
            label: "幽门螺旋杆菌感染",
            prop: "pylori",
          },
          {
            label: "空腹糖耐量受损",
            prop: "sugar",
          },
          {
            label: "动脉粥样斑块形成",
            prop: "artery",
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.permission.health_userjk_add,
        viewBtn: this.permission.health_userjk_view,
        delBtn: this.permission.health_userjk_delete,
        editBtn: this.permission.health_userjk_edit,
      };
    },
    ids() {
      const ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  methods: {
    onLoad() {
      const wxUserId = this.$route.query.wxUserId;
      getSubHealth(wxUserId).then((res) => {
        this.data = res.data;
      });
    },
  },
};
</script>
